<template>
    <tr class="dashboard__list_learner_table_item">
        <td class="dashboard__list_learner_table_item_name">
            <div class="columns is-vcentered">
                <div class="column">{{ sessionEventName }}</div>
            </div>
        </td>
        <td class="dashboard__list_learner_table_item_startdate">
            {{ sessionDate }}
            <div class="dashboard__list_learner_table_item_startdate_time">Time: {{ sessionTime }}</div>
        </td>
        <td class="dashboard__list_learner_table_item_location">
            {{ sessionVenueLocation }}
            <div class="dashboard__list_learner_table_item_location_room" v-if="sessionRoomLocation">Room: {{ sessionRoomLocation }}</div>
        </td>
        <td class="dashboard__list_learner_table_item_state">
            <component-status v-if="sessionStatus" :size="'full'" :status="sessionStatus"/>
        </td>
        <td class="dashboard__list_learner_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'dashboard-list-learner-table-item-collapse'"
                        :icon="true"
                        :icon-name="collapseActive ? 'chevron-up' : 'chevron-down'"
                        :theme="'default'"
                        @click="performEmit('emit-collapse', index)"
                    />
                </div>
                <template v-if="name !== 'lms-superadmin-users-profile-edit-learning-history-events'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'dashboard-list-learner-table-item-actions-primary'"
                            @click="handlePrimaryButtonRedirect(primaryButtonData.routeName, primaryButtonData.hash)"
                        >{{ primaryButtonData.text }}
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button-menu
                            ref="buttonmenu"
                            :buttons="[
                            {
                                key: 'add-to-outlook',
                                name: 'Add to Outlook'
                            }
                        ]"
                            @emit-add-to-outlook="performAddToOutlook"
                        />
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'

export default {
  name: 'dashboard-list-learner-table-item',
  components: { ComponentButtonMenu, ComponentButton, ComponentStatus },
  computed: {
    sessionId () {
      return this.item.occurrenceId
    },
    sessionEventName () {
      return this.item.name || this.item.eventName
    },
    sessionEventId () {
      return this.item.eventId
    },
    sessionStatus () {
      return this.item.bookingStatus || this.item.learnerStatus
    },
    sessionSpaces () {
      const available = Number(this.item.maxBookingLimit)
      const bookings = Number(this.item.bookings)
      return `${available - bookings} / ${available}`
    },
    sessionOccurrenceItems () {
      return this.item.occurrenceItems || this.item.sessions
    },
    sessionVenueLocation () {
      let location = this.item.location
      let occurrenceItems = this.sessionOccurrenceItems
      let platform = occurrenceItems && occurrenceItems.length && occurrenceItems[0] ? occurrenceItems[0].platform : null

      return location || platform
    },
    sessionRoomLocation () {
      return this.item.roomLocation
    },
    sessionWorkspaceId () {
      return this.item.workspaceId
    },
    sessionTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.firstDate))
    },
    sessionDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.firstDate))
    },
    //
    currentWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    primaryButtonData () {
      let text
      let hash
      let routeName
      switch (this.sessionStatus) {
        default:
          text = 'View'
          routeName = 'ebs-session-show'
          break
      }
      return { text, hash, routeName }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    name: {
      type: String
    },
    index: {
      type: [Number, String]
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    handleSwitchWorkspaceRedirect (to) {
      const currentWorkspaceId = this.currentWorkspaceId
      const sessionWorkspaceId = this.sessionWorkspaceId

      if (currentWorkspaceId !== sessionWorkspaceId) {
        this.$store.dispatch('authUserLoginSSOWorkspace', sessionWorkspaceId).then(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `Your workspace has been switched.`,
            status: 'success'
          })
          this.$router.push(to)
        }).catch(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `You can't be redirected to the session due to issues with switching workspace.`,
            status: 'error'
          })
        })
      } else {
        this.$router.push(to)
      }
    },
    handlePrimaryButtonRedirect (routeName, hash) {
      this.handleSwitchWorkspaceRedirect({ name: routeName, hash: hash, params: { sessionId: this.sessionId, eventId: this.sessionEventId } })
    },
    performAddToOutlook () {
      this.$store.dispatch('dashboardGenerateIcal', this.sessionId).finally(() => {
        this.$refs.buttonmenu.closeMenu()
      })
    }
  }
}
</script>
